module.exports = new __parcel__URL__("hi-tom_3.9438c9df.mp3").toString();